// extracted by mini-css-extract-plugin
module.exports = {"title":"forgotPasswordPage_title__WhagH"};